module.exports = __webpack_public_path__ + "img/dch2.df9ee475.jpg";